<template>
    <svg class="svg-loader" v-if="isSaving">
        <use
            :xlink:href="
                require('@/assets/img/icons/loader.svg') +
                '#layer'
            "
        />
    </svg>
</template>

<script>
export default {
    props: {
        isSaving: {
            type: Boolean,
            default: false,
        }
    },
}
</script>